// extracted by mini-css-extract-plugin
export default {"picBox":"index_picBox_kL7eP"};